

























import Modal from '../Base.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import Brand from '@/services/Brand';
import jQuery from 'jquery';
@Component({
     name: 'PolicyNotListed',
     components: {
          Modal,
          Brand
     },
})
export default class PolicyNotListed extends Vue {
     private closeModal() {
          jQuery('#notListed').modal('hide');
     }
     get details() {
		return Brand.getBrandInformation();
	}
}
